import React from "react"

interface ConnectivityRecoveryContextValue {
  isRecoveryActive: boolean
  registerRecoverySurface: () => () => void
}

interface ConnectivityRecoveryProviderProps {
  children: React.ReactNode
}

const ConnectivityRecoveryContext =
  React.createContext<ConnectivityRecoveryContextValue>({
    isRecoveryActive: false,
    registerRecoverySurface: () => () => undefined,
  })

export const ConnectivityRecoveryProvider: React.FC<
  ConnectivityRecoveryProviderProps
> = ({ children }) => {
  const [activeCount, setActiveCount] = React.useState(0)

  // Stable identity is required so recovery screens can register from useLayoutEffect.
  const registerRecoverySurface = React.useCallback(() => {
    setActiveCount((count) => count + 1)

    return () => {
      setActiveCount((count) => Math.max(0, count - 1))
    }
  }, [])

  const value = React.useMemo(
    () => ({
      isRecoveryActive: activeCount > 0,
      registerRecoverySurface,
    }),
    [activeCount, registerRecoverySurface]
  )

  return (
    <ConnectivityRecoveryContext value={value}>
      {children}
    </ConnectivityRecoveryContext>
  )
}

export const useConnectivityRecovery = () =>
  React.use(ConnectivityRecoveryContext)
